try{self['workbox:broadcast-update:4.1.1']&&_()}catch(e){}// eslint-disable-line